const setSpots = set => spots => set(state => {
  return {
    ...state,
    spots
  };
}, false, 'SET_SPOTS');

export default setSpots;
